import { Table, Tbody, Tr, Th } from '@chakra-ui/react';
import React from 'react';

import type { InternalTransaction } from 'types/api/internalTransaction';

import { AddressHighlightProvider } from 'lib/contexts/addressHighlight';
import { useI18n } from 'lib/i18n/context';
import { currencyUnits } from 'lib/units';
import { default as Thead } from 'ui/shared/TheadSticky';

import { ADDRESS_LIST_KEYS } from '../i18n';
import AddressIntTxsTableItem from './AddressIntTxsTableItem';

interface Props {
  data: Array<InternalTransaction>;
  currentAddress: string;
  isLoading?: boolean;
}

const AddressIntTxsTable = ({ data, currentAddress, isLoading }: Props) => {
  const { t } = useI18n();

  return (
    <AddressHighlightProvider>
      <Table>
        <Thead top={ 68 }>
          <Tr>
            <Th width="15%">{ t(ADDRESS_LIST_KEYS.fields.parentTxnHash) }</Th>
            <Th width="15%">{ t(ADDRESS_LIST_KEYS.fields.type) }</Th>
            <Th width="10%">{ t(ADDRESS_LIST_KEYS.fields.block) }</Th>
            <Th width="40%">{ t(ADDRESS_LIST_KEYS.fields.fromTo) }</Th>
            <Th width="20%" isNumeric>
              { t(ADDRESS_LIST_KEYS.fields.valueWithSymbol, { symbol: currencyUnits.ether }) }
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          { data.map((item, index) => (
            <AddressIntTxsTableItem
              key={ item.transaction_hash + '_' + index }
              { ...item }
              currentAddress={ currentAddress }
              isLoading={ isLoading }
            />
          )) }
        </Tbody>
      </Table>
    </AddressHighlightProvider>

  );
};

export default AddressIntTxsTable;
